import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { MdEdit } from "react-icons/md";
import CartonService from "../services/CartonService";

const CartonMaster = ({ isLoggedIn }) => {
  const cartonService = new CartonService();
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDt",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setStatee] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const [showDialog, setShowDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [formErrors, setFormErrors] = useState({
    cartonName: "",
    cartonSize: "",
    cartondesc: ""
  });
  const [formData, setFormData] = useState({
    cartonName: "",
    cartondesc: "",
    cartonSize: "",
    IsActive: true
  });
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");

    if (storedToken) {
      setStatee((prevData) => ({
        ...prevData,
        loading: true
      }));
      fetchCartonData();
      setStatee((prevData) => ({
        ...prevData,
        loading: false
      }));
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  function fetchCartonData() {
    cartonService
      .GetCarton(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setStatee((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setStatee((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setStatee((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const handleButtonClick = (row) => {
    const editMode = () => {
      setSelectedRow(row);
      setFormData({
        CartonId: row.cartonId,
        cartonName: row.cartonName || "",
        cartonSize: row.cartonSize || "",
        cartondesc: row.cartondesc || "",
        IsActive: row.isActive || false
      });
      if (row) {
        openDialog(false); // Edit action
      } else {
        openDialog(true); // Add action
      }
    };

    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
            rounded text-sm hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const openDialog = (isAdd) => {
    if (isAdd) {
      setShowDialog(true);
      setSelectedRow(null);
    } else {
      setShowDialog(true);
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setFormData({
      cartonName: "",
      cartonSize: "",
      cartondesc: "",
      IsActive: true
    });
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value
    }));
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "cartonName":
        if (value.length < 1) {
          IsValid = false;
          errors.cartonName = "Please enter carton name.";
        } else errors.cartonName = "";
        break;
      case "cartondesc":
        if (value.length < 1) {
          IsValid = false;
          errors.cartondesc = "Please enter carton description.";
        } else errors.cartondesc = "";
        break;
      case "cartonSize":
        if (!/^\d+$/.test(value)) {
          IsValid = false;
          errors.cartonSize = "Please enter a valid number for carton size.";
        } else {
          errors.cartonSize = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      if (selectedRow) {
        try {
          setStatee((prevData) => ({
            ...prevData,
            loading: true
          }));
          const apiUrl = `${process.env.REACT_APP_API_URL}CartonMaster/CreateUpdateCarton`;

          const CartonData = {
            CartonId: selectedRow.cartonId,
            cartonName: formData.cartonName,
            cartonSize: formData.cartonSize,
            cartondesc: formData.cartondesc,
            IsActive: formData.IsActive
          };

          cartonService.CreateUpdateCarton(CartonData).then((response) => {
            setStatee((prevData) => ({
              ...prevData,
              loading: false
            }));
            if (response.responseCode === "200") {
              toast.success("Carton Updated Successfully!");
              setFormData({
                cartonName: "",
                cartondesc: ""
              });
              setSelectedRow(null);
              setShowDialog(false);
              fetchCartonData();
            } else if (response.responseCode === "400") {
              toast.error(response.responseMessage);
            }
          });
        } catch (error) {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("Carton Update failed:", error);
          toast.error(error.message);
        }
      } else {
        try {
          const formDataToSend = {
            cartonName: formData.cartonName,
            cartonSize: formData.cartonSize,
            cartondesc: formData.cartondesc,
            IsActive: formData.IsActive
          };

          cartonService.CreateUpdateCarton(formDataToSend).then((res) => {
            if (res.responseCode === "200") {
              // Display success message
              toast.success(res.responseMessage);
            } else {
              // Display error message
              toast.error(res.responseMessage);
            }

            handleDialogClose();
            fetchCartonData();
          });
        } catch (error) {
          console.error("Error creating carton:", error);
        }
      }
    }
  };
  const searchFilter = (e) => {
    const value = e.target.value;
    setStatee((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchCartonData();
  };

  const getLazyLoadingValues = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchCartonData();
  };

  const onPage = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    fetchCartonData();
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Carton Size Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <Button
          onClick={openDialog}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
        >
          (+) Add Carton
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="UserMaster"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="cartonName"
                    header="Carton Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="cartonSize"
                    header="Carton Size"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="cartondesc"
                    header="Carton Description"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="createdDate"
                    header="Created Date"
                    sortable={true}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={handleButtonClick}
                    header="Action"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            PaperProps={{ style: { backgroundColor: "black" } }}
            className="add"
          >
            <DialogTitle style={{ color: "white", textAlign: "center" }}>
              {selectedRow ? "Update Carton" : "Add Carton"}
            </DialogTitle>
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  margin="dense"
                  label="Carton Name"
                  type="text"
                  name="cartonName"
                  value={formData.cartonName}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.cartonName}
                  helperText={formErrors.cartonName}
                />
                <TextField
                  margin="dense"
                  label="Carton Size"
                  type="text"
                  name="cartonSize"
                  value={formData.cartonSize}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.cartonSize}
                  helperText={formErrors.cartonSize}
                />
                <TextField
                  margin="dense"
                  label="Carton Description"
                  type="text"
                  name="cartondesc"
                  value={formData.cartondesc}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.cartondesc}
                  helperText={formErrors.cartondesc}
                />
                <div className="row justify-content-center mt-3">
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.IsActive}
                          onChange={handleFormChange}
                          name="IsActive"
                          color="primary"
                        />
                      }
                      label="Active"
                    />
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default CartonMaster;
